import $ from 'jquery';
import { AmplitudeEventProperty, logAmplitudeEvent } from 'chairisher/util/analytics';

/**
 * Accepts an individual nav link and builds amplitudeEventObject to track the `link - click` event
 *
 * @param {object} $link
 * @param {string} year
 */
function logAmplitudeLinkClick($link, year) {
    const amplitudeEventObject = {};
    amplitudeEventObject[AmplitudeEventProperty.CTA_URL] = $link.attr('href');
    amplitudeEventObject[AmplitudeEventProperty.CTA_NAME] = $link.text().trim();
    amplitudeEventObject[AmplitudeEventProperty.CTA_POSITION] = `resale report ${year} - nav link`;

    logAmplitudeEvent('link - click', amplitudeEventObject);
}

/**
 * Attaches logAmplitudeLinkClick() to each of the desktop and mobile nav links
 *
 * @param {string} year
 */
export function trackNavLinks(year) {
    $('.js-nav-link-desktop, .js-nav-link-mobile').on('click', ({ currentTarget }) => {
        const $link = $(currentTarget);
        logAmplitudeLinkClick($link, year);
    });
}

/**
 * Tracks a page view for the resale report
 *
 * @param {string} year
 */
export function trackPageView(year) {
    logAmplitudeEvent(`screen - resale report ${year}`);
}
